﻿export default class PrintIt {

	private elements = document.querySelectorAll('.js-print');

	constructor() {

		if (!this.elements.length) return;

		this.attachPrintButtonClicks();

	}

	private attachPrintButtonClicks() {

		for (var i = 0; i < this.elements.length; i++) {

			this.elements[i].addEventListener('click', function (e) {

				window.print();
				e.preventDefault();

			});

		}

	}

}

